export const phoneRegExp =
  /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;


export const titleOptions = [
  {id: "1", value: "doctor", label: "Doctor"},
  {id: "2", value: "ms", label: "Ms."},
  {id: "3", value: "mr", label: "Mr."},
  {id: "4", value: "professor", label: "Prof."},
];

export const companyOptions = [
  {
    id: "4",
    value: "Airline / Airport / Ground Service Provider",
    label: "Airline / Airport / Ground Service Provider",
  },
  {id: "5", value: "Travel Agency / Tour Operator", label: "Travel Agency / Tour Operator"},
  {id: "3", value: "Governmental Parties", label: "Governmental Parties"},
  {
    id: "1",
    value: "Health Diagnostic Provider",
    label: "Health Diagnostic Provider (Labs, Clinics, Hospitals, Medical Facilities etc.)",
  },
  {id: "2", value: "COVID-19 Vaccine Administer", label: "COVID-19 Vaccine Administer"},
  {id: "6", value: "Other", label: "Other"},
];

